export default class UnitDetailBasicInfo {
  constructor(data = {}) {
    this.unitType = data.unitType;
    this.unitLevel = data.unitLevel;
    this.floors = data.floors;
  }
}
